@for (leg of legs(); track leg.testId; let index = $index) {
  @if (index !== 0) {
    <div
      class="w-full bg-kz-layout-featured flex flex-row items-center py-2"
      [attr.data-testid]="testIdPrefix() + '-stop-' + index"
    >
      <div class="px-2">
        <mat-icon class="operator-icon" svgIcon="walking" color="primary" />
      </div>
      <div>
        <div>{{ 'Flight Stop in' | translate }} {{ leg.segment.departureCityName ?? '' }}</div>
        <div class="text-secondary">
          {{ allSegments() | stopTime: index }}
        </div>
      </div>
    </div>
  }
  <div class="flights-logo-container" [attr.data-testid]="leg.testId">
    <div class="flex">
      @if (leg.segment.airlineCode | runFunction: this.getAirlineIconFn; as icon) {
        <mat-icon class="svg-airline" [svgIcon]="icon" />
      }
      <div class="text-kz-primary font-medium flex items-center gap-1">
        <div>
          {{ leg.segment.flightCode }}
        </div>
        <app-flight-class [flightClass]="leg.segment.class" [isBlock]="isBlock()" />
      </div>
    </div>
    <div class="flights-plan pt-3">
      <div class="flights-row">
        <span class="country-index">{{ leg.segment.departureAirportCode }} </span>
        <span class="separator"></span>
        <span class="airplane-icon">
          <mat-icon svgIcon="airplane-outline-2" color="primary" />
        </span>
        <span class="separator"></span>
        <span class="country-index">{{ leg.segment.arrivalAirportCode }} </span>
      </div>
      <div class="flights-row">
        <span class="country-name">
          {{ leg.segment.departureCityName }}
        </span>
        <span class="country-name">
          {{ leg.segment.arrivalCityName }}
        </span>
      </div>
      <div class="flights-row flex-wrap gap-x-2">
        <span>
          {{ leg.segment.departureFlightDate | date: dateTimeFormat }}
        </span>
        <span>
          {{ leg.segment.arrivalFlightDate | date: dateTimeFormat }}
          @if (leg.days > 0) {
            <b class="text-kz-primary" [attr.data-testid]="leg.testId + '-days'">+{{ leg.days }}</b>
          }
        </span>
      </div>
    </div>
  </div>
}
